var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-section"},[_c('div',{staticClass:"service-section-top"},[_c('p',{staticClass:"service-section-title"},[_c('span',[_vm._v(_vm._s(this.label))])])]),_c('div',{staticClass:"service-section-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }